// TopBar — narrow dark strip at the very top of every page.
//
// For the standalone help portal we keep only contact info — phone and
// email. No external links to the marketing site, no LinkedIn, no LOGIN
// button. Users navigating to the help center don't need promotional CTAs.
//
// To change the contact details, edit the constants below.

const PHONE = '(+91) 9844774400';
const PHONE_TEL = '9844774400';
const EMAIL = 'info@myeduate.com';

export default function TopBar() {
  return (
    <div className="top-bar">
      <div className="top-bar__inner">
        <div className="top-bar__group">
          <a href={`tel:${PHONE_TEL}`}>{PHONE}</a>
          <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
        </div>
        <div className="top-bar__group">
          <span className="top-bar__tagline">Help Center</span>
        </div>
      </div>
    </div>
  );
}
